// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5609229f","455":"bbb916f2","977":"97045b4f","987":"39706aa8"}[chunkId] + ".chunk.js";
};